import { useState, useContext, useEffect } from 'react'
import { useQuery } from 'react-query'
import { FeedbackContext } from '../../../../Components/Context/FeedbackContext'
import { Loading } from '../../../../Components/Loading/Loading'
import { ErrorConnection } from '../../../../Components/Error/Error'
import { Spinner } from 'react-bootstrap'
import * as Api from '../../../../api/Api'
import { useGetToken } from '../../../../Hooks/CustomHooks'
import * as Utilities from '../../../../Components/Utils/Utils'
import $ from 'jquery'
import { Helmet } from 'react-helmet'
import '../mapplic.css'
import GuardarContrato from './GuardarContrato'
import Modal from 'react-bootstrap/Modal'

function Mantenimiento({ unidadEconomicaId, unidadEconomicaName }) {
  const [mapplicObj, setMapplicObj] = useState(null)
  const token = useGetToken()

  const [abirGuardarContrato, setAbirGuardarContrato] = useState(false)
  const [guardadoExitoso, setGuardadoExitoso] = useState(false)
  const [messageResponse, setMessageResponse] = useState('')

  const listColor = ['#87c141', '#434df4', '#f4e21a', '#e74157']

  const [contrato, setContrato] = useState('')
  const [local, setLocal] = useState('')
  const [idObj, setIdObj] = useState('')
  const [listaContratosSearch, setListaContratosSearch] = useState([])
  const [listaTitlesSearch, setListaTitlesSearch] = useState([])

  let listaContratosTemp = []
  let listaTitlesTemp = []
  let listaIdTemp = []

  let { data: dataLista } = useQuery(
    ['ListaContratos', {}],
    async () => await Api.MapaMantenimiento_ListaContratos({ token: token }),
    {
      enabled: true,
    }
  )
  useEffect(() => {
    if (dataLista) {
      if (dataLista.data === null) {
        setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId })
      } else {
        dataLista.data.forEach((contrato) => {
          listaContratosTemp.push(contrato.numContrato)
          listaTitlesTemp.push(contrato.title)
        })
        setListaContratosSearch(listaContratosTemp)
        setListaTitlesSearch(listaTitlesTemp)
      }
    }
  }, [dataLista])

  const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext)
  let { data, isLoading, isError, error, isFetching } = useQuery(
    [
      'MapaCalorMantenimiento',
      {
        unidadEconomica: unidadEconomicaId,
      },
    ],
    async () =>
      await Api.MapaCalorMantenimiento({ unidadEconomicaId: unidadEconomicaId, token: token }),
    {
      enabled: true,
    }
  )
  useEffect(() => {
    if (data) {
      if (data.data === null) {
        setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId })
      } else {
        setJsonMapFinalwithSettings(data.data.mapaCalor, data.data.listaCategorias)
      }
    }
  }, [data])

  function onAfterGuardar(action, message) {
    setAbirGuardarContrato(false)
    setMessageResponse(message === '' ? 'Guardado Exitoso' : message)
    if (action === true) setGuardadoExitoso(true)
  }
  function guardadoExistosoModal() {
    window.location.reload(false)
  }

  function setJsonMapFinalwithSettings(jsonResponseFromServer, rangos) {
    const settings = {
      mapwidth: '1300',
      mapheight: '1000',
      defaultstyle: 'normal',
      styles: [],
      groups: [],
    }

    rangos.forEach(function (currentValue, index, array) {
      settings.styles.push({
        class: 'statusClass' + currentValue.value,
        base: {
          fill: listColor[index],
          'fill-opacity': '0.4',
        },
        hover: {
          'fill-opacity': '0.8',
        },
        active: {
          fill: 'green',
          'fill-opacity': '1',
        },
      })
      settings.groups.push({
        id: 'statusCategory' + currentValue.value,
        title: currentValue.label,
        color: listColor[index],
        legend: 'true',
        style: 'statusClass' + currentValue.value,
      })
    })

    let data = jsonResponseFromServer

    data.levels.forEach(function (level, index1, array) {
      if (parseInt(level.id) < 0) level['title'] = 'Sótano ' + Math.abs(parseInt(level.id))
      level['map'] =
        '/../mapas/' +
        unidadEconomicaName.toLowerCase().replace(/\s/g, '') +
        '/piso_' +
        level.id +
        '.svg'
      level.locations.forEach(function (elementLocation, index2, array) {
        elementLocation['pin'] = 'hidden'
        elementLocation['titleModal'] = elementLocation['title']
        elementLocation['title'] =
          elementLocation['title'].length > 10
            ? elementLocation['title'].slice(0, 15) + '...'
            : elementLocation['title']
        elementLocation['category'] = 'statusCategory' + elementLocation.categoria
        elementLocation['style'] = 'statusCategory' + elementLocation.categoria
      })
    })

    let returnedTarget = Object.assign(data, settings)

    let mapplicObjTemp = {
      source: returnedTarget,
      height: 'auto',
      // minimap: true,
      lightbox: false,
      sidebar: false,
      hovertip: true,
      maxscale: 10,
      developer: false,
      highlight: true,
      zoom: true,
      mousewheel: true,
      closezoomout: true,
      thumbholder: true,
    }

    //#region Funcion Colorea Bloque
    setTimeout(function () {
      $('.mapplic-pin').each(function (index) {
        $(this).css('background-color', 'white')
      })
    }, 1000)

    let encontrados = 0
    let locationNull = false
    function setColorLocatarios() {
      for (let indexLevel = 0; indexLevel < data.levels.length; indexLevel++) {
        if (locationNull && encontrados < 3) break
        const element = data.levels[indexLevel]
        for (let indexLocation = 0; indexLocation < element.locations.length; indexLocation++) {
          if (locationNull && encontrados < 3) break
          const elementLocation = element.locations[indexLocation]

          locationNull = $('#' + elementLocation.id).length == 0
          if (!locationNull) encontrados++
          else console.log(elementLocation.id, $('#' + elementLocation.id).length)

          if (elementLocation.numContrato != '') {
            // $("#" + (elementLocation.id)).attr("class", "colorLocatarioMapeado");
            let groupTemp = settings.groups.find(
              (group) => group.id == 'statusCategory' + elementLocation.categoria
            )
            let colorTemp = groupTemp != null ? groupTemp.color : 'Transparent'
            let styleTemp = `background-color: ${colorTemp} !important; fill: ${colorTemp} !important;`

            $('#' + elementLocation.id).attr('style', styleTemp)

            $('#' + elementLocation.id).attr('data-toggle', 'tooltip')
            $('#' + elementLocation.id).attr('data-placement', 'Tooltip on top')
            $('#' + elementLocation.id).attr('data-bs-html', 'true')
            $('#' + elementLocation.id).attr(
              'title',
              elementLocation.id + ' : ' + elementLocation.titleModal
            )

            $('#' + elementLocation.id).on('click touchstart', function () {
              setAbirGuardarContrato(true)
              setIdObj(elementLocation.id)
              setLocal(elementLocation.titleModal)
              setContrato(elementLocation.numContrato)
            })

            listaIdTemp.push(elementLocation.id)
          }
        }
      }

      $('polyline, polygon, path, rect').each(function (index, element, array) {
        $(element).on('click touchstart', function () {
          let x = $('.mapplic-coordinates-x').html()
          let y = $('.mapplic-coordinates-y').html()
          let elementTemp = { id: element.id, x: x, y: y }
          setIdObj(element.id)

          if (
            listaIdTemp
              .map((elem) => elem.replace(/\s+/g, ''))
              .indexOf(element.id.replace(/\s+/g, '')) < 0
          ) {
            setLocal('')
            setContrato('')
          }
          setAbirGuardarContrato(true)
        })
      })

      if (locationNull)
        setTimeout(function () {
          locationNull = false
          setColorLocatarios()
        }, 1500)
    }

    setTimeout(function () {
      setColorLocatarios()
    }, 1500)

    //#endregion

    setMapplicObj(mapplicObjTemp)
  }

  if (isLoading) return <Loading />
  if (isError) return <ErrorConnection error={error} />
  return (
    <>
      {isFetching ? (
        <Spinner animation='grow' variant='secondary' />
      ) : data?.data && data?.data?.mapaCalor?.levels.length > 0 ? (
        <>
          <div className='application'>
            <Helmet>
              <script>
                {`
                                        if (` +
                  JSON.stringify(mapplicObj) +
                  ` != null) {
                                            $('#mapplic_container_all_in').mapplic(` +
                  JSON.stringify(mapplicObj) +
                  `);
                                            setTimeout(function () {
                                                $('[data-toggle="tooltip"]').tooltip({ container: 'body' })
                                            }, 2000)
                                        }
                                    `}
              </script>
            </Helmet>
          </div>

          {abirGuardarContrato && (
            <GuardarContrato
              unidadEconomicaId={unidadEconomicaId}
              idObj={idObj}
              contrato={contrato}
              setContrato={setContrato}
              local={local}
              setLocal={setLocal}
              listaContratosSearch={listaContratosSearch}
              listaTitlesSearch={listaTitlesSearch}
              setSmShow={onAfterGuardar}
            />
          )}

          <Modal
            show={guardadoExitoso}
            onHide={() => setGuardadoExitoso(false)}
            aria-labelledby='contained-modal-title-vcenter'
            centered
          >
            <Modal.Header>
              <Modal.Title id='example-modal-sizes-title-sm' style={{ margin: 'auto' }}>
                {messageResponse}
              </Modal.Title>
            </Modal.Header>
            <Modal.Footer style={{ margin: 'auto' }}>
              <button type='button' className='btn btn-primary' onClick={guardadoExistosoModal}>
                Aceptar
              </button>
            </Modal.Footer>
          </Modal>

          <div id='mapplic_container_all_in'></div>
        </>
      ) : (
        <div class='alert alert-warning' role='alert'>
          Actualmente no existen datos para este Mall.
        </div>
      )}
    </>
  )
}

export default Mantenimiento
